import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      this.buttonTarget.disabled = true;
      this.buttonTarget.textContent = "🎤 Não suportado";
      return;
    }

    this.recognition = new SpeechRecognition();
    this.recognition.lang = "pt-BR";
    this.recognition.continuous = false;   // importante para detectar pausas
    this.recognition.interimResults = true;

    this.isRecording = false;
    this.finalText = this.inputTarget.value.trim();
    this.interimText = "";

    this.recognition.onresult = (event) => {
      const res = event.results[0];
      const text = res[0].transcript.trim();

      if (!res.isFinal) {
        // texto parcial enquanto fala
        this.interimText = text;
      } else {
        // texto final – aqui é onde colocamos o ponto e nova linha
        const sentence = text.replace(/[.?!]+$/, ""); // remove pontuação duplicada

        // adiciona ponto + quebra de linha
        this.finalText +=
          (this.finalText ? "\n" : "") +          // nova linha (se já houver texto)
          sentence + ".";                          // ponto final automático

        this.interimText = "";
      }

      // mostra final + interim
      this.inputTarget.value =
        this.finalText +
        (this.interimText ? " " + this.interimText : "");
    };

    this.recognition.onend = () => {
      if (this.isRecording) {
        this.interimText = "";
        this.recognition.start(); // reinicia para nova frase
      }
    };
  }

  toggle() {
    if (this.isRecording) {
      this.isRecording = false;
      this.recognition.stop();
      this.buttonTarget.textContent = "🎤 Falar";
      return;
    }

    this.finalText = this.inputTarget.value.trim();
    this.interimText = "";

    this.isRecording = true;
    this.buttonTarget.textContent = "🛑 Parar";

    this.recognition.start();
  }
}
